import { useAppTranslation } from './useAppTranslation.js';
/** Human-readable role name (the stored value stays `admin`, shown as Verwalter / Manager). */
export function useRoleLabel() {
  const { t } = useAppTranslation();
  return (role: string): string => {
    switch (role) {
      case 'owner': return t('common.roles.owner', 'Owner');
      case 'admin': return t('common.roles.admin', 'Verwalter');
      case 'department_lead': return t('common.roles.departmentLead', 'Abteilungsleiter');
      case 'superadmin': return 'Superadmin';
      default: return t('common.roles.member', 'Mitglied');
    }
  };
}
